export const Marquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="relative border-y border-border/60 py-6 overflow-hidden bg-muted/20">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {items.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-heading text-2xl sm:text-3xl tracking-tight text-foreground/70 whitespace-nowrap px-10">{t}</span>
              <span className="w-2 h-2 rotate-45 bg-accent inline-block shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
